import { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { handleLoaderEvent } from "../utils/LoaderEmitter";
import { removeCustomerDelegatedUser } from "../utils/Api";

import Select from "react-select";

import { Modal } from "react-bootstrap";

import "../styles/EditClientUser.css";

const EditDelegatedUser = ({ user, setDelegatedUserApiStatus }) => {
  const [editModalShow, setEditModalShow] = useState(false);
  const [availableDelegation, setAvailableDelegation] = useState();
  const [confirmationModal, setConfirmationModalShow] = useState(false);
  const [deleteDelegatedUser, setDeleteDelegatedUser] = useState();

  let { id } = useParams();

  const editModalHandleClose = () => {
    setEditModalShow(false);
  };

  const editModalHandleShow = () => {
    setEditModalShow(true);
  };

  const confirmationModalShow = (user) => {
    setConfirmationModalShow(true);
    setDeleteDelegatedUser(user);
  };
  const confirmationModalClose = () => {
    setConfirmationModalShow(false);
  };

  const onDelegatedUserSelection = () => {
    setEditModalShow(false);
  };
  const deleteCustomerDelegatedUser = async () => {
    let response = await removeCustomerDelegatedUser(id, deleteDelegatedUser?.user_id);
    if (response) {
      confirmationModalClose();
      handleLoaderEvent.emit("loader", true);
      setDelegatedUserApiStatus((prev) => !prev);
      toast.info("Delegated user removed successfully");
    }
  };

  return (
    <>
      <tr className="table-content border-bottom table-row" key={user?.id}>
        <td style={{ width: "20%" }}>{user?.first_name}</td>
        <td style={{ width: "15%" }}>{user?.last_name}</td>
        <td style={{ width: "25%" }}>{user?.email}</td>
        <td style={{ width: "40%" }} className="actions p-3 mx-auto row">
          <button type="button" className="delete-button offset-2 col-8 px-3" onClick={() => confirmationModalShow(user)}>
            Delete
          </button>
        </td>
      </tr>

      <Modal className="edit-modal" show={editModalShow} onHide={editModalHandleClose}>
        <Modal.Body>
          <Modal.Title>Add Delegated User</Modal.Title>
          <div className="container mt-3">
            <Select isMulti="true" isClearable="false" onChange={onDelegatedUserSelection} options={availableDelegation} />
            <div className="d-flex justify-content-center mt-5">
              <button className="save-button p-2 px-4" onClick={editModalHandleClose}>
                Close
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="activation-modal" show={confirmationModal} onHide={confirmationModalClose}>
        <Modal.Body>
          <Modal.Title className="status-modal-title text-center">Confirm Action</Modal.Title>
          <div className="status-modal-sub-title mt-4 text-center">Are you sure you want to remove {deleteDelegatedUser?.first_name + " " + deleteDelegatedUser?.last_name} as a delegated user ?</div>
          <div className="d-flex justify-content-end mt-5">
            <button className="cancel-button p-2 px-4 me-3" onClick={confirmationModalClose}>
              Cancel
            </button>
            <button className="save-button p-2 px-4" onClick={() => deleteCustomerDelegatedUser()}>
              Delete
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditDelegatedUser;
